import { useLayoutEffect, useRef, type ReactNode } from "react";

/** One boxless exact-address refusal, with its own arrival focus and return act. */
export function CourseworkRefusal({ id, children }: { id: string; children: ReactNode }) {
  const root = useRef<HTMLElement>(null);
  useLayoutEffect(() => {
    root.current?.focus();
    const frame = requestAnimationFrame(() => root.current?.focus());
    return () => cancelAnimationFrame(frame);
  }, []);
  return <section ref={root} role="alert" tabIndex={-1} data-bento-page={id} data-journey="coursework-refusal" data-page-refusal="unavailable" className="grid gap-3 outline-none">{children}</section>;
}
